import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../core'

export const RESOURCE = {
  payload: {
    description:
      'Contains IDC Category and IDC Subcategory: A classification of indirect costs used in indirect cost rate proposal.',
    name: 'IDC Functions',
    partialId: PartialId.Standard.create('func_idc'),
  },
  type: core.quiver.Resource.Type.DmsDimension,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsDimension>
